export default __webpack_public_path__ + "static/media/AirbnbCerealLight.b2312000.woff";